import { DefaultButton, IPanelStyles, List, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { IArubaRemoteSignRequest, IField, ITextField } from '../../../../shared/interfaces';
import AppUtilities from '../../../../shared/Utilities/appUtilities';
import { RootState } from '../../../../store';
import RemoteSignForm from './RemoteSignForm';

const queryString = require('query-string');

const panelStyles: Partial<IPanelStyles> = {
    content: {
        padding: '24px 20px 0px',
        display: 'flex',
        flexFlow: 'column',
        overflow: 'hidden',
    },
    scrollableContent: {
        display: 'flex',
        flexFlow: 'column',
        overflow: 'hidden',

    }
}




const initialFields: IField[] = [
    {
        displayName: "Username",
        internalName: "username",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    } as ITextField,
    {
        displayName: "Password",
        internalName: "password",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        type: "password",
        canRevealPassword: true
    } as ITextField,
    {
        displayName: "Codice OTP",
        internalName: "codiceOTP",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
       system: false,
        internalValue: "",
        valid: false,
        touched: false,
        type: "password",
        canRevealPassword: true
    } as ITextField,


];

export interface RemoteSignPanelProps {
    loading?: boolean
    extraCssClass?: string
    remoteSignPanelIsOpen: boolean
    onRemoteSignSubmit: (mail) => void
    onRemoteSignDismiss: () => void

}

type Props = RemoteSignPanelProps & RouteComponentProps

const RemoteSignPanel: React.FunctionComponent<Props> = (props) => {

    let [panelIsOpen, { setTrue: openRemoteSignPanel, setFalse: dismissRemoteSignPanel }] = useBoolean(props.remoteSignPanelIsOpen);
    const [fields, setFields] = useState<IField[]>(initialFields);

    let [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    let [messageBarType, setMessageBarType] = useState<MessageBarType>(MessageBarType.info)
    let [messageBarText, setMessageBarText] = useState<string>('')

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectCurrentProtocol = (state: RootState) => state.appNavigationReducer.protocol
    const currentProtocol = useSelector(selectCurrentProtocol);


    const inputChangedHandler = (newField: IField) => {

        const updatedFields = [...fields];

        let itemIndex = updatedFields.findIndex(el => el.internalName === newField.internalName);
        updatedFields[itemIndex] = { ...newField };

        setFields(updatedFields);
    }


    const checkFormValidity = (): boolean => {
        let isValid = true;

        let errors: string[] = [];

        let newFields = { ...fields };



        Object.values(fields).forEach((field: IField, index) => {
            let newField = { ...field };
            let fieldValidity = AppUtilities.checkFieldValidity(newField)
            if (!fieldValidity) {
                isValid = false;
            }
            newFields[newField.internalName] = {
                ...newField,
                touched: true,
                valid: fieldValidity
            }

        });

        setFields(newFields);

        if (isValid)
            dismissMessageBar()
        else {
            errors.push("compilare correttamente tutti i campi obbligatori");
            let errorMessage = AppUtilities.getMessageFromErrorObjectValidity(errors);
            setMessageBarText(errorMessage);
            setMessageBarType(MessageBarType.error)
            showMessageBar();

        }
        return isValid;
    }

    const remoteSignPanelSubmit = () => {
        if (checkFormValidity()) {

            let arubaRemoteSignRequest: Partial<IArubaRemoteSignRequest> = {
                user: fields.find(el => el.internalName === 'username')?.internalValue,
                userPWD: fields.find(el => el.internalName === 'password')?.internalValue,
                otpPwd: fields.find(el => el.internalName === 'codiceOTP')?.internalValue,
            }

            props.onRemoteSignSubmit(arubaRemoteSignRequest);
            setFields(initialFields);
        }

    }

    const remoteSignPanelDismiss = () => {


        props.onRemoteSignDismiss();
    }

    const onRenderFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Firma"
                    onClick={remoteSignPanelSubmit}

                />
                <DefaultButton
                    onClick={remoteSignPanelDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }

    return (
        <Panel
            key='remoteSignPanel'

            isLightDismiss
            isOpen={panelIsOpen}
            type={PanelType.custom}
            customWidth={'600px'}
            styles={panelStyles}
            headerText="Firma"
            focusTrapZoneProps={{
                isClickableOutsideFocusTrap: true,
                forceFocusInsideTrap: true,
            }}
            onDismiss={remoteSignPanelDismiss}
            onRenderFooterContent={onRenderFooterContent}
            // Stretch panel content to fill the available height so the footer is positioned
            // at the bottom of the page
            isFooterAtBottom={false}

        >
            {
                messageBarIsVisible &&
                <MessageBar
                    messageBarType={messageBarType}
                    isMultiline={false}
                    onDismiss={dismissMessageBar}
                    dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
            }
            <div className={"flex flex-column position-relative overflow-hidden"}>

                <div className={`position-relative my-scroll-div`}>

                        <RemoteSignForm
                            fields={fields}
                            onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
                        />


               </div>
            </div>



        </Panel>

    );
}

export default RemoteSignPanel;
